export default {"src":"/_next/static/media/br_path.74cc2eb7.svg","height":4,"width":17,"blurWidth":0,"blurHeight":0};